import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const addStakeholderConsignmentType = async (data) => {
    try {
        await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholderconsignment`,
            data,
        );
    } catch (e) {
        console.error(e);
    }
};


export const getConsignmentName = async (id) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholderconsignment/${id}`,
        );
        return response.data.sctConsignmentType;
    } catch (e) {
        console.error(e);
    }
};

export const addConsignmentType = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholderconsignment`,
            data,
        );
    } catch (e) {
        console.error(e);
    }
};

export const updateConsignmentType = async (data) => {
    try {
        const response = await gatewayInstance.put(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholderconsignment`,
            data,
        );
    } catch (e) {
        console.error(e);
    }
};

export const consignmentById = async (id) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholderconsignment/${id}`,
        );
        console.log(response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const consignmentsByCustomer = async (customerId) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/stakeholderconsignment/customerconsignment/${customerId}`,
        );

        return response.data.map((item) => ({
            key: item.id,
            text: item.text,
            value: item.id,
        }));
    } catch (e) {
        console.error("consignmentsByCustomer error:", e?.message || e);
    }
};
